import { Slot } from "../events/Slot";
import type { SlotReadyEvent } from "../events/SlotReadyEvent";
import { eventQBus } from "@otto-ec/global-resources/event-q-bus";

export class BenefitService {
	registerEventListener(): Promise<unknown[]> {
		return Promise.all([eventQBus.on("ft9.benefit.slotReady", this.onSlotReady.bind(this))]);
	}

	async onSlotReady(event: SlotReadyEvent): Promise<void> {
		switch (event.slotId) {
			case Slot.BOUNCE_LAYER: {
				event.targetElement.innerHTML = `<ft9-bounce-v1 variation-id="${event.variationId}"></ft9-detailview-v1>`;
				return Promise.resolve();
			}
			case Slot.PARTNER_BENEFIT: {
				const searchParams = new URLSearchParams(window.location.search);
				const autoActivateBenefitId = searchParams.get("benefitId")?.replaceAll("/", "").replaceAll("%2F", "").trim();

				if (!this.isUndefinedOrUUID(autoActivateBenefitId)) {
					return Promise.reject(new Error(`Invalid benefitId: ${autoActivateBenefitId}`));
				}

				event.targetElement.innerHTML = `<ft9-detailview-v1 team="ft5" feature="pdpDetailview" variation-id="${event.variationId}" product-id="${event.productId}" ${autoActivateBenefitId ? `benefit-id="${autoActivateBenefitId}"` : ""} ${event.eventMergeId ? `event-merge-id="${event.eventMergeId}"` : ""}></ft9-detailview-v1>`;

				return Promise.resolve();
			}
		}
	}

	isUndefinedOrUUID(value: string | undefined): boolean {
		if (value === undefined) {
			return true;
		}

		const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
		return uuidRegex.test(value);
	}
}
